import { useEffect } from "react";
import { Link } from "react-router-dom";

export const CALENDLY_URL = "https://calendly.com/patrick-2besales/mezzanine-financing-initial-call";
export const CALENDLY_EMBED = CALENDLY_URL + "?hide_gdpr_banner=1&primary_color=0f766e";

export function Booking({ t }) {
  useEffect(() => {
    if (!document.querySelector('script[src*="assets.calendly.com"]')) {
      const s = document.createElement("script");
      s.src = "https://assets.calendly.com/assets/external/widget.js";
      s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  return (
    <div className="card cal-card" data-testid="booking-card">
      <h3 className="h3">{t.cardT}</h3>
      <p className="p">{t.cardP}</p>
      <div
        className="calendly-inline-widget"
        data-url={CALENDLY_EMBED}
        style={{ minWidth: 300, height: 720 }}
        data-testid="calendly-widget"
      />
      <div>
        <a href={CALENDLY_URL} target="_blank" rel="noopener" className="btn" data-testid="cal-open">
          {t.openBtn}
        </a>
      </div>
      <p className="p" style={{ fontSize: "0.9rem" }}>
        {t.notePre}
        <Link to="/privacy">{t.noteLink}</Link>
        {t.notePost}
      </p>
    </div>
  );
}
